import React__default from 'react';

var Triangle7 = function Triangle7(props) {
  var className = props.className,
    style = props.style;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    style: style,
    width: "28",
    height: "31",
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    style: {
      mixBlendMode: 'multiply'
    }
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 28.7256V2.27439C0.00139103 1.87653 0.107365 1.48595 0.307413 1.14137C0.507461 0.796793 0.794633 0.510194 1.14045 0.309995C1.48627 0.109796 1.87871 0.00295292 2.27887 6.03366e-05C2.67903 -0.00283225 3.073 0.0983266 3.42171 0.293505L26.8431 13.5245C27.1943 13.7227 27.4865 14.01 27.6897 14.357C27.8929 14.704 28 15.0984 28 15.5C28 15.9016 27.8929 16.296 27.6897 16.643C27.4865 16.99 27.1943 17.2773 26.8431 17.4755L3.42171 30.7065C3.073 30.9017 2.67903 31.0028 2.27887 30.9999C1.87871 30.997 1.48627 30.8902 1.14045 30.69C0.794633 30.4898 0.507461 30.2032 0.307413 29.8586C0.107365 29.5141 0.00139103 29.1235 0 28.7256H0Z",
    fill: "#4871F0"
  })));
};
Triangle7.defaultProps = {
  className: undefined,
  style: undefined
};
var Triangle7$1 = Triangle7;

export { Triangle7$1 as default };
